import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from '../auth/states/auth.state';

@Directive({
    selector: '[rkIsSuperUser]',
    standalone: false
})
export class IsSuperUserDirective implements OnInit {
  isViewDisplayed = false;

  _showIfSuperuser = true;

  @Select(AuthState.isSuperUser)
  isSuperUser$: Observable<boolean>;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef) { }

  ngOnInit(): void {
    this.isSuperUser$.subscribe(su => {
      if (su) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
